import { Classroom } from "./Classroom.model";

export class IconLibrary {

	static i18nPrefix = '#icon library: ';

	static mapFromServer(data: any): IconLibrary {
		return (new IconLibrary).setFromServerData(data);
	}

	public id ?: string;
	public name ?: string;
	public group ?: string;
	public classroomId ?: string;
	public editable = true;

	constructor() {
	}

	/**
	 * @param data
	 */
	setFromServerData(data: any): IconLibrary {
		this.id = '' + data.id;
		this.name = data.name;
		this.group = data.group;

		if (data.classroom) {
			this.classroomId = data.classroom.id;
		}

		this.editable = data.editable;

		return this;
	}

	getGroupName() {
		if (!this.group) {
			return '';
		}

		return this.group.substring(0, 1).toUpperCase() + this.group.substring(1);
	}

	/**
	 * Return the translation key for the name of the level,
	 * or null if this is a custom name.
	 */
	get nameTranslationKey(): string | null {
		if (this.name?.startsWith('$')) {
			return IconLibrary.i18nPrefix + this.name.substring(1);
		}

		return null;
	}

	isEditable(scope: string) {

		if (!this.editable) {
			return false;
		}

		switch (scope) {
			case 'global':
				return !this.classroomId;

			case 'classroom':
				return !!this.classroomId;
		}

	}

	getServerData() {
		const out: any = {
			name: this.name,
			group: this.group
		};

		if (this.classroomId) {
			out.classroom = {
				id: this.classroomId
			};
		}

		return out;
	}

	setFromModel(iconLibrary: IconLibrary) {
		this.id = iconLibrary.id;
		this.name = iconLibrary.name;
		this.group = iconLibrary.group;
		this.classroomId = iconLibrary.classroomId;
	}

	clone(): IconLibrary {
		const iconLibrary = new IconLibrary();
		iconLibrary.setFromModel(this);

		return iconLibrary;
	}

}
